// Two equal paths burn away from the top centre and end at the measured pill edges.
// The pill's centre must sit on the bottom stroke (height - 1).
export function capsuleTimerPaths(
  width: number,
  height: number,
  pillWidth: number,
) {
  const radius = height / 2 - 1;
  const left = radius + 1;
  const right = width - left;
  const mid = width / 2;
  const bottom = height - 1;
  // The narrow stats tag's timer can be slightly wider than its straight
  // bottom segment. Keep the actual pill edge rather than clamping to the bend.
  const halfPill = Math.max(0, Math.min(pillWidth / 2, mid - 1));
  return [
    `M ${mid} 1 H ${left} A ${radius} ${radius} 0 0 0 ${left} ${bottom} H ${mid - halfPill}`,
    `M ${mid} 1 H ${right} A ${radius} ${radius} 0 0 1 ${right} ${bottom} H ${mid + halfPill}`,
  ];
}
